module.exports = __webpack_public_path__ + "static/media/13-12.f3a4e492.mp3";